export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
			ElWidth: null,
			ElScrollWidth: null,
		};
		this.elID = null;
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "lesalert";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			let elScope = this.$el;
			this.checkSizes();

			window.addEventListener("resize", () => {
				this.checkSizes();
			});
		}
	}
	checkSizes() {
		this.$el.classList.remove("is-scrollable");
		this.ElWidth = this.$el.offsetWidth;
		this.ElScrollWidth = this.$el.scrollWidth;
		// console.log(this.ElWidth, this.ElScrollWidth);

		if (this.ElWidth < this.ElScrollWidth) {
			this.$el.classList.add("is-scrollable");
		} else {
			this.$el.classList.remove("is-scrollable");
		}
	}
}
